import { Component, Inject, Input } from '@angular/core';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { PhaseCardItemDto } from '@shared/src/dtos/phase/PhaseCardItemDto';
import { PhaseDisplacementDto } from '@shared/src/dtos/phase/PhaseDisplacementDto';
import { ContadorsDto } from '@shared/src/dtos/phase/slot/ContadorsDto';
import { RouteCardItemExpandDto } from '@shared/src/dtos/route/RouteCardItemExpandDto';
import { HomeController, HTime, RouteController, SecurityController, SharedAsideFactory } from '@shared/src/public-api';

@Component({
    selector: 'routephase-timeline',
    templateUrl: './shared.route.routephasetimeline.component.html',
    styleUrls: ['./shared.route.routephasetimeline.component.scss']
})
export class RoutePhaseTimelineComponent {

    constructor(private routeController: RouteController, private openRouteController: OpenRouteController, @Inject('SecurityController') private securityController: SecurityController, private homeController: HomeController, @Inject('SharedAsideFactory')
    public sharedAsideFactory: SharedAsideFactory) {

    }

    public phasesDisplacement: PhaseDisplacementDto[];
    public options: OptionsStripDto;
    @Input()
    public route: RouteCardItemExpandDto;

    public _contadors: ContadorsDto;
    @Input()
    set contadors(value: ContadorsDto) {
        this.route = RouteCardItemExpandDto.build(value);

        if (this.route != null && this.route.phasesDisplacement != null && this.route.phasesDisplacement.length != 0)
            this.phasesDisplacement = [...this.route.phasesDisplacement].sort((a, b) => Number(a.theoreticalDistanceOrigin) - Number(b.theoreticalDistanceOrigin));
    }

    @Input()
    public isExwork: boolean = false;

    @Input()
    set routeId(value: number) {
        if (value == null || value == 0)
            return;
        if(!this.isExwork)
            this.routeController.getRouteCardItemExpand(value).subscribe(data => {
                this.route = data;

            if (this.route != null && this.route.phasesDisplacement != null && this.route.phasesDisplacement.length != 0)
                this.phasesDisplacement = [...this.route.phasesDisplacement].sort((a, b) => Number(a.theoreticalDistanceOrigin) - Number(b.theoreticalDistanceOrigin));
            });
    }

    @Input()
    set uuid(value: string) {
        if (value == null || value == "")
            return;
        if(this.isExwork)
            this.openRouteController.getRouteExpandExword(value).subscribe(data => {
                this.route = data;
            });
    }


    openAside(phase: PhaseCardItemDto) {
        if (phase)
            this.sharedAsideFactory.invokePhaseInfo(phase.phaseId, this.isExwork, phase).then(value => { });
    }


    getPosition(phaseId: number): Object {
        if (!this.phasesDisplacement || this.phasesDisplacement.length === 0) {
            return { left: '0px' };
        }
        const entries = this.phasesDisplacement;
        const first = entries[0];
        const last = entries[entries.length - 1];

        if (phaseId === first.phaseId) return { left: '35px' };
        if (phaseId === last.phaseId) return { right: '-17px' };

        const phase = entries.find(d => d.phaseId === phaseId);
        const posi = entries.indexOf(phase);

        if (phase) {
            const number = (phase.theoreticalDistanceOrigin * 100) / last.theoreticalDistanceOrigin;
            return { left: `${Math.max(number, posi * 10)}%` };
        }

        return { left: '50%' };
    }


    getDistance(phase: PhaseCardItemDto) {
        if (this.route != null && this.phasesDisplacement != null)
            var phaseD = this.phasesDisplacement.find(d => d.phaseId === phase.phaseId);
            if (phaseD)
                return this.fixNumber(phaseD.theoreticalDistanceOrigin);

        return "-";
    }

    fixNumber(n: number) {
        return HLong.toLocaleString(Math.round(n), this.securityController);
    }

    pretty(value: any): string {
        console.log(JSON.stringify(value));
        return JSON.stringify(value);
    }
}
